class ConnectionService {
    constructor() {
        this.isOnline = navigator.onLine;
        this.listeners = new Set();
        this.checkInterval = null;

        this.init();
    }

    init() {
        // Escuchar eventos nativos del navegador
        window.addEventListener('online', this.handleOnline.bind(this));
        window.addEventListener('offline', this.handleOffline.bind(this));

        // Verificación periódica simple cada 30 segundos
        this.startPeriodicCheck();

        // Verificación inicial
        this.checkConnectivity();
    }

    handleOnline() {
        console.log('🟢 Navigator dice: ONLINE');
        this.updateConnectionStatus(true);
    }

    handleOffline() {
        console.log('🔴 Navigator dice: OFFLINE');
        this.updateConnectionStatus(false);
    }

    startPeriodicCheck() {
        // Verificación simple cada 30 segundos
        this.checkInterval = setInterval(() => {
            this.checkConnectivity();
        }, 30000);
    }

    stopPeriodicCheck() {
        if (this.checkInterval) {
            clearInterval(this.checkInterval);
            this.checkInterval = null;
        }
    }

    // Verificación de conectividad simplificada
    async checkConnectivity() {
        try {
            // Si navigator.onLine es false, no hay conexión
            if (!navigator.onLine) {
                this.updateConnectionStatus(false);
                return;
            }

            // Ping simple a Google con timeout corto
            const isConnected = await this.pingUrl('https://www.google.com/favicon.ico', 3000);
            this.updateConnectionStatus(isConnected);

        } catch (error) {
            console.error('❌ Error verificando conectividad:', error);
            this.updateConnectionStatus(false);
        }
    }

    // Ping simplificado a una sola URL
    async pingUrl(url, timeout = 3000) {
        return new Promise((resolve) => {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => {
                controller.abort();
                resolve(false);
            }, timeout);

            fetch(url, {
                method: 'HEAD',
                mode: 'no-cors',
                cache: 'no-cache',
                signal: controller.signal
            })
                .then(() => {
                    clearTimeout(timeoutId);
                    resolve(true);
                })
                .catch(() => {
                    clearTimeout(timeoutId);
                    resolve(false);
                });
        });
    }

    updateConnectionStatus(isOnline) {
        if (this.isOnline !== isOnline) {
            this.isOnline = isOnline;
            console.log('🔄 Estado de conexión actualizado:', isOnline ? '✅ ONLINE' : '❌ OFFLINE');

            // Notificar a todos los listeners
            this.listeners.forEach(callback => {
                try {
                    callback(isOnline);
                } catch (error) {
                    console.error('❌ Error en listener de conexión:', error);
                }
            });
        }
    }

    // Método para que los componentes se suscriban a cambios de conectividad
    subscribe(callback) {
        this.listeners.add(callback);

        // Devolver el estado actual inmediatamente
        callback(this.isOnline);

        // Devolver función para desuscribirse
        return () => {
            this.listeners.delete(callback);
        };
    }

    // Obtener estado actual
    getConnectionStatus() {
        return this.isOnline;
    }

    // Forzar verificación manual
    async forceCheck() {
        await this.checkConnectivity();
        return this.isOnline;
    }

    // Limpiar recursos
    destroy() {
        this.stopPeriodicCheck();
        window.removeEventListener('online', this.handleOnline.bind(this));
        window.removeEventListener('offline', this.handleOffline.bind(this));
        this.listeners.clear();
    }

}

// Crear instancia singleton
const connectionService = new ConnectionService();

export default connectionService;